import classes from "./PackageList.module.css";
import printIcon from "../../images/printIcon.svg";
import { BackBtn } from "../../components/buttons/backBtn/BackBtn";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { BaseTable } from "../../components/UI/baseTable/BaseTable";
import { PageWrapper } from "../../components/UI/pageWrapper/PageWrapper";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { getPackagingList } from "../../redux/package/getPackagingList";
import { generatePackagingPDF } from "../../helperFunctions/generatePackagingListPdf";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentDate } from "../../helperFunctions/getCurrentDate";

export function PackageList() {
  const { selectedDriverInfo, language } = useSelector((state) => state.global);
  const { list, status, minTrunkDimensions, totalVolume } = useSelector(
    (state) => state.packagingList
  );
  const { t } = useTranslations();
  const pageText = t.packageListPage;
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPackagingList({ driver_id: +params.id, language }));
  }, [dispatch, params.id, language]);

  const currentDate = (
    <div className={classes.currentDateContainer}>{getCurrentDate()}</div>
  );

  const pageTitle = (
    <>
      {selectedDriverInfo?.u_firstname} {selectedDriverInfo?.u_lastname}{" "}
      {pageText.packagingList} {currentDate}
    </>
  );

  function handlePrintPDF() {
    const filename = `${selectedDriverInfo?.u_firstname}_packaging_list`;
    generatePackagingPDF(list, pageTitle, filename, pageText);
  }

  const backBtn = [<BackBtn to="/drivers" key="back-btn" />];

  const printBtn = [
    <button
      key="print-btn"
      className={classes.printBtn}
      onClick={handlePrintPDF}
      disabled={list && list?.length === 0}
    >
      <img src={printIcon} alt="Print" />
    </button>,
  ];

  const columns = [
    { label: pageText.order },
    { label: pageText.customer },
    { label: pageText.pickupAddress },
    { label: pageText.dropoffAddress },
    { label: pageText.dimensions },
    { label: pageText.volume },
  ];

  return (
    <PageWrapper title={pageTitle} backButton={backBtn} buttons={printBtn}>
      <BaseTable
        underRowsElements={
          <div
            style={{
              color: "#676c7e",
              display: "flex",
              gap: "8px",
              width: "100%",
            }}
          >
            <div className={classes.minTrunkCapacity}>
              <h4> {pageText.minTrunkDimensions}</h4>
              <p className={classes.currentDateContainer}>
                {minTrunkDimensions
                  ? Object.entries(minTrunkDimensions)
                      .filter(([k]) => k !== "volume")
                      .map(([, v]) => v)
                      .join("x") + "m"
                  : "0"}
              </p>
            </div>
            <div className={classes.minTrunkCapacity}>
              <h4> {pageText.minTrunkCapacity}</h4>
              <p className={classes.currentDateContainer}>{totalVolume} m³</p>
            </div>
          </div>
        }
        status={status}
        items={list}
        errorMsg={pageText.errorFetching}
        noItemsMsg={pageText.noPackagingList}
        columns={columns}
        columnAndRowWidth={"250px"}
        resultsContainerHeight={"calc(100vh - 270px)"}
        rows={
          list &&
          list?.map((item) => [
            item.p_id,
            item.customer_name,
            item.pickup_address,
            item.dropoff_address,
            item?.dimensions
              ? `${item.dimensions.width ?? ""}${
                  item.dimensions.width ? "x" : ""
                }${item.dimensions.height ?? ""}${
                  item.dimensions.height ? "x" : ""
                }${item.dimensions.depth ?? ""}${
                  item.dimensions.depth ? "m" : ""
                }`
              : "",

            item?.dimensions?.volume != null
              ? item.dimensions.volume.toFixed(3)
              : "",
          ])
        }
      />
    </PageWrapper>
  );
}
